<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" v-model="isDialogOpened" width="600" scrollable>
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        Thêm điểm danh đến
        <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="cancel">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="py-6">
        <div class="mb-3">
          * Sau khi thêm điểm danh xe tuyến thành công, thông báo sẽ được gửi đến Phụ huynh (gửi theo Tự động theo đăng
          ký trong Sổ liên lạc)
        </div>
        <v-form ref="form">
          <v-row>
            <v-col cols="12">
              <DateIOSPicker
                label="Ngày"
                :date.sync="date"
                outlined
                class="required"
                :rules="[$rules.required, $rules.date]"
                dense
              />
            </v-col>
            <v-col cols="12">
              <AutocompleteStudent
                :syncedValue.sync="selectedStudent"
                return-object
                label="Học sinh"
                class="required"
                outlined
                dense
                clearable
                hide-details="auto"
                :rules="[$rules.required]"
              />
            </v-col>
            <v-col cols="12">
              <AutocompleteBus
                label="Tuyến xe"
                class="required"
                outlined
                dense
                clearable
                hide-details="auto"
                :rules="[$rules.required]"
                @change="busChange"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                label="Chiều di chuyển"
                v-model="selectedBusTimeline"
                :items="busTimelines"
                item-text="title"
                item-value="value"
                dense
                outlined
                clearable
                hide-details="auto"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                label="Trạng thái"
                v-model="selectedBusTrackingStatus"
                :items="busTrackingStatuses"
                item-text="title"
                item-value="value"
                dense
                outlined
                clearable
                hide-details="auto"
              />
            </v-col>
            <!-- <v-col cols="12">
              <v-select
                label="Xe tuyến"
                v-model="selectedBus"
                :items="buses"
                item-text="name"
                item-value="id"
                dense
                outlined
                clearable
                return-object
                hide-details="auto"
              />
            </v-col> -->
            <v-col cols="12" class="d-flex flex-row align-center">
              <div class="mr-2">Giờ lên/xuống xe (24h) <span class="error--text">*</span></div>
              <TimeInput
                label="Giờ (24h)"
                outlined
                dense
                outline
                :date.sync="time"
                :selectedDate="getCurrentDate"
                class="required"
                :rules="[$rules.required, $rules.time]"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn class="ma-2" outlined light depressed @click="cancel">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="ma-2" dark depressed color="#0D47A1" @click="save">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { BusSchedules, BusStop, BusCheckin, BusStudentCheckin } from '@/plugins/api'
import { get } from 'lodash'
import moment from 'moment'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'
import TimeInput from '@/components/basic/TimeInput.vue'
import AutocompleteStudent from '@/components/basic/input/AutocompleteStudent.vue'
import AutocompleteBus from '@/components/basic/input/AutocompleteBus.vue'

export default {
  components: {
    DateIOSPicker,
    AutocompleteStudent,
    AutocompleteBus,
    TimeInput
  },
  data() {
    return {
      isDialogOpened: false,
      date: moment().toISOString(),
      selectedStudent: {},
      time: '',
      selectedBusTrackingStatus: {},
      busTrackingStatuses: [
        {
          title: 'Đã lên xe',
          value: 'attendance'
        },
        {
          title: 'Đã xuống xe',
          value: 'left'
        }
      ],
      selectedBusTimeline: {},
      selectedBus: {},
      buses: []
    }
  },
  computed: {
    ...mapGetters('constant', ['busTimelines']),
    getCurrentDate() {
      return moment(this.date).format('DD/MM/YYYY')
    }
  },
  async created() {},
  methods: {
    ...mapActions('attendance', ['checkinAttendance']),
    openDialog() {
      this.isDialogOpened = true
    },
    busChange(bus) {
      this.selectedBus = bus
    },
    async save() {
      if (!this.$refs.form.validate()) {
        return
      }
      try {
        this.$loading.active = true
        const addData = {
          student: get(this.selectedStudent, 'id', ''),
          bus: get(this.selectedBus, 'id', '')
        }
        const dateTime = moment(this.date).set({
          hour: moment(this.time).get('hour'),
          minute: moment(this.time).get('minute')
        })
        // console.log(this.date)
        // console.log(this.time, moment(this.time).get('hour'), moment(this.time).get('minute'))
        // console.log(dateTime.format('DD/MM/YYYY HH:MM'), dateTime.get('hour'), dateTime.get('minute'))
        addData.timeCheckIn = moment(dateTime).toISOString()

        if (this.selectedBusTrackingStatus) {
          addData.status = this.selectedBusTrackingStatus
        }

        // Load bus schedule
        const busScheduleParams = {}
        const dayOfWeek = moment(this.date)
          .locale('en')
          .format('dddd')
          .toLowerCase()
        if (dayOfWeek) {
          busScheduleParams.dayOfWeek = dayOfWeek
        }
        const timeline = this.selectedBusTimeline && this.selectedBusTimeline.split('-')
        // console.log(timeline)
        if (timeline && timeline.length) {
          busScheduleParams.periodTime = timeline[0]
          busScheduleParams.direction = timeline[1]
        }
        // console.log(busScheduleParams)
        const busSchedule = await BusSchedules.fetch(busScheduleParams)
        // console.log(busSchedule)
        if (busSchedule && busSchedule.length) {
          addData.bus_schedule = get(busSchedule[0], 'id', '')
        }
        // Load bus stop
        const busStopParams = {
          bus: get(this.selectedBus, 'id', '')
        }
        if (addData.bus_schedule) {
          busStopParams.busSchedule = addData.bus_schedule
        }
        const busStops = await BusStop.fetch(busStopParams)
        // console.log(busStops)
        if (busStops && busStops.length) {
          addData.bus_stop = get(busStops[0], 'id', '')
        }

        // Load dummy bus_tracking
        const busTrackings = await BusCheckin.fetch({ _limit: -1 })
        if (busTrackings && busTrackings.length) {
          addData.bus_tracking = get(busTrackings[0], 'id', '')
        }

        // console.log(addData)
        await BusStudentCheckin.create(addData)
        this.$alert.addSuccess()
      } catch (error) {
        console.error(error)
        this.$alert.addError()
      }
      this.$loading.active = false
      this.isDialogOpened = false
    },
    reset() {
      this.selectedStudent = null
      this.time = null
      this.$refs.form.resetValidation()
    },
    cancel() {
      this.isDialogOpened = false
      this.reset()
    }
  }
}
</script>
